<template>
  <div class="row">
    <div
      v-if="topicText"
      class="col-1 d-flex align-items-center"
      :class="topicTextClass"
    >
      {{ topicText }}
    </div>
    <div
      class="row font-weight-bold color-black font-12"
      :class="topicText ? 'col-11' : 'col-12'"
    >
      <div
        v-for="(item, index) in historialItems"
        :key="index"
        class="cube col-1 px-0"
        :class="classObject({ item, index })"
      >
        <div class="col-12 text-center pt-2 header">
          <div class="col-12">{{ item.title }}</div>
          <div class="col-12">{{ item.subtitle }}</div>
        </div>
        <div
          class="checkbox-container col-12 text-center"
          :class="checkboxContainerClass"
        >
          <input
            v-if="!item.readonly"
            :id="`accordion-cb-${index}`"
            :checked="item.isChecked"
            class="mt-2"
            :disabled="item.isDisabled || item.isBlocked"
            name="accordion-cb"
            type="radio"
            :value="item"
            @input="emitValue(item)"
          />
          <i
            v-if="item.readonly && item.isChecked"
            aria-hidden="true"
            class="fa fa-check-circle fa-lg mt-2 pt-1 icon-readonly"
          />
          <i
            v-if="item.readonly && !item.isChecked"
            aria-hidden="true"
            class="far fa-circle fa-lg mt-2 pt-1 icon-readonly"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SingleHistorialAccordion',
  props: {
    topicTextClass: {
      type: String,
      default: '',
      meta: {
        description: 'Clase para nombre de contexto',
        example: 'object-class',
      },
    },
    topicText: {
      type: String,
      default: '',
      meta: {
        description: 'Nombre de contexto',
        example: 'Prueba',
      },
    },
    items: {
      type: Array,
      default: () => [],
      required: true,
      meta: {
        description:
          'Arreglo de objetos para seleccionar elementos del histórico',
        example: '{ title, subtitle, isChecked, isDisabled }',
      },
    },
    cubeClass: {
      type: String,
      default: '',
      meta: {
        description: 'Clase para caja de acordeón',
        example: 'object-class',
      },
    },
    checkboxContainerClass: {
      type: String,
      default: '',
      meta: {
        description: 'Clase para contenedor de checkbox',
        example: 'object-class',
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historialItems: [],
    };
  },
  computed: {
    classObject() {
      return ({ item, index }) => {
        let isFirstElement = index === 0;
        let isLastElement = this.historialItems.length === index + 1;
        return {
          ...this.cubeClass,
          'cube-unchecked': !item.isChecked,
          'cube-checked': item.isChecked,
          'cube-disabled': item.isDisabled,
          'cube-blocked': item.isBlocked,
          'first-item': isFirstElement,
          'last-item': isLastElement,
        };
      };
    },
  },
  watch: {
    items() {
      this.historialItems = [...this.items];
    },
  },
  methods: {
    emitValue(item) {
      this.historialItems.forEach((x) => (x.isChecked = false));
      item.isChecked = true;
      this.$emit('on-checked-historial-item', this.historialItems);
    },
  },
};
</script>
<style lang="scss" scoped>
$lightOrange: #fde9e5;
$orange: #ff7058;
$lightGray: #f7f7f7;
$whiteSmoke: #e2e2e2;
$blockedGray: #b8c3bc;
$blockedBorderGray: #9aa6a8;
$disabledTextGray: #e2e2e2;
$disabledLightGray: #c3c3c3;

.checkbox-container > input[type='radio'] {
  appearance: none;
  background-color: #fff;
  margin: 0px;
  font: inherit;
  width: 1.45em;
  height: 1.45em;
  border: 0.1em solid $disabledTextGray;
  border-radius: 50%;
}
.cube-unchecked {
  border: 1px solid $whiteSmoke;
  border-width: 1px 1px 1px 0px;
}
.icon-readonly {
  color: $orange;
}
.cube-checked {
  border: 1px solid $orange;
  background-color: $lightOrange;
}
.cube-checked .checkbox-container > input[type='radio']:checked {
  color: $orange;
  border: 0.4em solid $orange;
}
.cube-disabled {
  border: 1px solid $whiteSmoke;
  border-width: 1px 1px 1px 0px;
  color: $disabledLightGray;
  background-color: $lightGray;
}
.cube-disabled .checkbox-container > input[type='radio'] {
  color: $disabledTextGray;
  background-color: $disabledTextGray;
}
.cube-blocked {
  border: 1px solid $blockedBorderGray;
  background-color: $blockedGray;
}
.cube-blocked .checkbox-container > input[type='radio'] {
  border: 1px solid $blockedGray !important;
  background-size: cover !important;
  background-image: url("data:image/svg+xml,%3Csvg id='Component_547_1' data-name='Component 547 – 1' xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Crect id='Rectangle_2495' data-name='Rectangle 2495' width='20' height='20' rx='10' fill='%23455a5f'/%3E%3Cpath id='xmark' d='M7.776,102.62a.8.8,0,1,1-1.132,1.132l-2.638-2.637-2.638,2.636a.8.8,0,0,1-1.133-1.133L2.873,99.98.235,97.343A.8.8,0,0,1,1.368,96.21l2.638,2.64,2.639-2.639a.8.8,0,1,1,1.133,1.133L5.138,99.982Z' transform='translate(5.994 -89.981)' fill='%23e8ebe9'/%3E%3C/svg%3E%0A") !important;
}
.menu ::v-deep {
  .custom-icon-view {
    .dot {
      padding: 1rem;
    }
  }
}
.first-item {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-width: 1px 1px 1px 1px;
}
.last-item {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
